import { useAtomValue } from 'jotai';
import { atomWithQuery } from 'jotai-tanstack-query';
import { createTableQueryOptions } from '@/components/table';

interface ShopOption {
  key: string;
  label: string;
}

interface ShopOptionsResponse {
  success: boolean;
  data: Array<{ name: string; key: string }>;
}

// Fallback shop options (in case API is not ready)
const FALLBACK_SHOP_OPTIONS: ShopOption[] = [
  { key: 'WooCommerce', label: 'WooCommerce' },
  { key: 'Shopify', label: 'Shopify' },
  { key: 'PrestaShop', label: 'PrestaShop' },
  { key: 'Magento', label: 'Magento' },
  { key: 'OpenCart', label: 'OpenCart' },
  { key: 'BigCommerce', label: 'BigCommerce' },
  { key: 'Wix', label: 'Wix' },
  { key: 'Squarespace', label: 'Squarespace' },
  { key: 'DrupalCommerce', label: 'DrupalCommerce' },
  { key: 'VirtueMart', label: 'VirtueMart' },
  { key: 'Shopware', label: 'Shopware' },
  { key: 'VTEX', label: 'VTEX' },
  { key: 'SalesforceCommerceCloud', label: 'Salesforce Commerce Cloud' },
  { key: 'SAP_Hybris', label: 'SAP Hybris' },
  { key: 'CommerceTools', label: 'commercetools' },
  { key: 'Medusa', label: 'Medusa' }
];

// Query atom for shop options
// Note: API endpoint /ecommerce-platforms doesn't exist, so we always use fallback
export const shopOptionsQueryAtom = atomWithQuery<ShopOptionsResponse>((get) => {
  return createTableQueryOptions({
    queryKey: ['shop-options'] as const,
    queryFn: async () => {
      // API endpoint doesn't exist, always return fallback
      return {
        success: true,
        data: FALLBACK_SHOP_OPTIONS.map(opt => ({ name: opt.label, key: opt.key }))
      };
    },
    enabled: true
  });
});

export function useShopOptions(): ShopOption[] {
  const query = useAtomValue(shopOptionsQueryAtom);
  
  if (query.data?.data) {
    return query.data.data.map(item => ({
      key: item.key,
      label: item.name
    }));
  }
  
  // Return fallback if API hasn't loaded or failed
  return FALLBACK_SHOP_OPTIONS;
}



